module.exports = __webpack_public_path__ + "media/images/radicchio-153632c4795f842d967c7f39574a986c.jpg";